import { createContext, useContext } from 'react'
import { DEFAULT_BRANDING } from '../branding'
import type { FeedConfig } from './configTypes'

export const ConfigContext = createContext<FeedConfig>({
  organization: '',
  offering: undefined,
  name: '',
  branding: DEFAULT_BRANDING,
  surface: null,
  loading: true,
  error: null,
})

export function useFeedConfig() {
  return useContext(ConfigContext)
}
